<template>
  <div v-if="loading" class="fixed inset-0 z-9999 flex justify-center items-center"
       :class="isDarkMode ? 'bg-dark-opacity-50' : 'bg-white-opacity-50'"
  >
    <div class="rotate-15">
      <svg v-if="isDarkMode" class="w-30 h-40 wave" width="165" height="215" viewBox="0 0 165 215" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36.2549 108.286C40.579 79.5682 51.9177 0.0201246 62.68 6.35796C76.1327 14.2802 55.7133 93.4322 62.68 103.005C69.6466 112.578 81.9501 36.3256 95.6431 30.0539C109.336 23.7821 88.8649 116.209 85.2615 120.5C81.658 124.791 128.241 50.3161 130.403 69.1316C131.955 82.6434 116.994 121.446 108.529 140.549C107.687 142.448 107.266 143.398 107.451 143.596C107.503 143.652 107.567 143.691 107.641 143.712C107.902 143.785 108.55 142.981 109.847 141.372C122.656 125.475 150.946 91.0327 158.073 97.5616C166.361 105.154 117.596 209.662 70.74 209.662C19.1232 209.662 11.4969 127.181 7.43649 108.286C-3.03134 59.5756 47.1433 108.517 47.1433 139.051" stroke="white" stroke-width="10.2711" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <svg v-else class="w-30 h-40 wave" width="165" height="215" viewBox="0 0 165 215" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36.2549 108.286C40.579 79.5682 51.9177 0.0201246 62.68 6.35796C76.1327 14.2802 55.7133 93.4322 62.68 103.005C69.6466 112.578 81.9501 36.3256 95.6431 30.0539C109.336 23.7821 88.8649 116.209 85.2615 120.5C81.658 124.791 128.241 50.3161 130.403 69.1316C131.955 82.6434 116.994 121.446 108.529 140.549C107.687 142.448 107.266 143.398 107.451 143.596C107.503 143.652 107.567 143.691 107.641 143.712C107.902 143.785 108.55 142.981 109.847 141.372C122.656 125.475 150.946 91.0327 158.073 97.5616C166.361 105.154 117.596 209.662 70.74 209.662C19.1232 209.662 11.4969 127.181 7.43649 108.286C-3.03134 59.5756 47.1433 108.517 47.1433 139.051" stroke="#323232" stroke-width="10.2711" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'LoadingModule',

  props: {
    loading: Boolean
  },

  setup () {
    const { getters } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)

    return {
      isDarkMode
    }
  }
}
</script>

<style lang="scss" scoped>
.rotate-15 {
  transform: rotate(-15.0deg)
}

.bg-white-opacity-50 {
  background: rgba(255, 255, 255, 0.5);
}

.bg-dark-opacity-50 {
  background: rgba(#444, 0.5);
}

.wave {
  animation-name: wave-animation;
  animation-duration: 2.5s;
  animation-iteration-count: infinite;
  transform-origin: 50% 70%;
}

@keyframes wave-animation {
    0% { transform: rotate( 0.0deg) }
   10% { transform: rotate(30.0deg) }
   20% { transform: rotate(-20.0deg) }
   30% { transform: rotate(30.0deg) }
   40% { transform: rotate(-12.0deg) }
   50% { transform: rotate(20.0deg) }
   60% { transform: rotate( 0.0deg) }
  100% { transform: rotate( 0.0deg) }
}
</style>
